var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#FFFCF4",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234 459 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234 399 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 344 c-4 -4 -7 -48 -7 -97 l0 -90 -25 23 c-20 19 -28 21 -37 12 -10 -10 -2 -23 35 -59 l47 -47 45 44 c45 44 57 70 32 70 -8 0 -22 -10 -33 -21 -19 -21 -19 -21 -24 72 -5 84 -14 111 -33 93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 107 c0 -36 5 -68 12 -75 17 -17 419 -17 436 0 7 7 12 39 12 75 0 56 -2 63 -20 63 -18 0 -20 -7 -20 -55 l0 -55 -190 0 -190 0 0 55 c0 48 -2 55 -20 55 -18 0 -20 -7 -20 -63z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.dde3ad9efbf216c109c45b46e2a503e3.svg";
export { ForwardRef as ReactComponent };